// extracted by mini-css-extract-plugin
module.exports = {"search-box":"P_fx","search-box__input":"P_fy form-control","search-box__icon":"P_fz ml-2"};